import toast from 'react-hot-toast';

const LIC_STATUS_LABELS = {
  '1': 'Aguardando abertura',
  '2': 'Processo aberto',
  '3': 'Licença emitida',
  '4': 'Solicitada prorrogação',
  '5': 'Finalizado',
  '6': 'Suspensa',
  '7': 'Cassada',
};

/** @param {Record<string, unknown>} ent */
export function buildEnterpriseShareText(ent) {
  const name = ent.name || ent.nome || '—';
  const lines = [`Empreendimento — ${name}`, ''];
  if (ent.id != null && `${ent.id}`.length > 0) lines.push(`ID: ${ent.id}`);
  if (ent.cnpj) lines.push(`CNPJ: ${ent.cnpj}`);
  if (ent.type) lines.push(`Tipo: ${ent.type}`);
  if (ent.status) lines.push(`Status: ${ent.status}`);
  if (ent.address) lines.push(`Endereço: ${ent.address}`);
  const city = ent.city;
  const state = ent.state;
  if (city || state) lines.push(`Local: ${[city, state].filter(Boolean).join(' / ')}`);
  if (ent.latitude != null && ent.longitude != null) {
    lines.push(`Coordenadas: ${ent.latitude}, ${ent.longitude}`);
    lines.push(`Maps: https://www.google.com/maps?q=${ent.latitude},${ent.longitude}`);
  }
  return lines.join('\n').trim();
}

/**
 * @param {{
 *   licenca: Record<string, unknown>;
 *   tipoNome?: string | null;
 *   clienteNome?: string | null;
 *   empreendimentoNome?: string | null;
 *   condicionantes?: unknown[];
 * }} p
 */
export function buildLicenseShareText({
  licenca,
  tipoNome,
  clienteNome,
  empreendimentoNome,
  condicionantes = [],
}) {
  const num = licenca.numero != null ? String(licenca.numero) : '';
  const title = num ? `Licença ${num}` : 'Licença ambiental';
  const lines = [title, ''];
  if (licenca.id) lines.push(`ID: ${licenca.id}`);
  const st = licenca.status != null ? String(licenca.status) : '';
  if (st) {
    const label = LIC_STATUS_LABELS[st] || st;
    lines.push(`Status: ${label}`);
  }
  if (licenca.validade) {
    const v = String(licenca.validade);
    lines.push(`Validade: ${v.length >= 10 ? v.slice(0, 10) : v}`);
  }
  if (tipoNome) lines.push(`Tipo: ${tipoNome}`);
  if (clienteNome) lines.push(`Requerente: ${clienteNome}`);
  if (empreendimentoNome) lines.push(`Empreendimento: ${empreendimentoNome}`);
  if (licenca.observacao) {
    const o = String(licenca.observacao);
    lines.push(`Observação: ${o.length > 400 ? `${o.slice(0, 400)}…` : o}`);
  }
  const cond = Array.isArray(condicionantes) ? condicionantes : [];
  if (cond.length) {
    lines.push('');
    lines.push(`Condicionantes (${cond.length}):`);
    cond.slice(0, 8).forEach((c) => {
      lines.push(`• ${c?.condicionante ?? '—'}`);
    });
    if (cond.length > 8) lines.push(`… e mais ${cond.length - 8}`);
  }
  return lines.join('\n').trim();
}

/** @param {Record<string, unknown>} c */
export function buildComplaintShareText(c) {
  const lines = ['Denúncia ambiental', ''];
  if (c.id) lines.push(`ID: ${c.id}`);
  if (c.local) lines.push(`Local: ${c.local}`);
  if (c.cidade) lines.push(`Cidade: ${c.cidade}`);
  if (c.data) lines.push(`Data: ${c.data}`);
  if (c.status != null) lines.push(`Status: ${c.status}`);
  if (c.descricao) {
    const d = String(c.descricao);
    lines.push('');
    lines.push('Descrição:');
    lines.push(d.length > 600 ? `${d.slice(0, 600)}…` : d);
  }
  return lines.join('\n').trim();
}

export const shareOutreach = {
  /** @param {string} subject @param {string} text */
  async native(subject, text) {
    if (navigator.share) {
      try {
        await navigator.share({ title: subject, text });
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }
    await shareOutreach.copy(text);
  },

  /** @param {string} text */
  async copy(text) {
    try {
      await navigator.clipboard.writeText(text);
      toast.success('Copiado para a área de transferência');
    } catch {
      toast.error('Não foi possível copiar o texto');
    }
  },

  /** @param {string} text */
  whatsapp(text) {
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  },

  /** @param {string} subject @param {string} body */
  email(subject, body) {
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  },
};
